<template>
  <div id="wrapper" >
    <!-- <LeftMenu ref="leftMenu" @toggleLeftMenu="toggleLeftMenu"/> -->
    <div id="page-wrapper" class="gray-bg right-page-wrapper" style="overflow:auto;">
      <!--<TopHeader ref="topHeader" @toggleLeftMenu="toggleLeftMenu"/>-->
      <AppMain />
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import TopHeader from '@/components/layout/TopHeader'
import LeftMenu from '@/components/layout/LeftMenu'
import AppMain from '@/components/layout/AppMain'
export default {
  name: 'Home',
  components: {
    TopHeader,
    LeftMenu,
    AppMain,
  },
  mounted() {
    // $('#page-wrapper').css("min-height", $(window).height() - 61 + "px");
  },
  methods:{
    toggleLeftMenu(flag){
      console.log('home',flag)
      if(flag){
        $("#page-wrapper").removeClass("withOutLeftMenu")
        //this.$refs.leftMenu.showLeftMenu()
      }else{
        $("#page-wrapper").addClass("withOutLeftMenu")
        //this.$refs.leftMenu.hideLeftMenu()
      }

    }
  }
}
</script>

<style lang="less" scoped>
  .withOutLeftMenu{
    margin-left:0px !important;
  }
</style>
